module.exports = __webpack_public_path__ + "static/media/logo_color_fav.4f402fce.png";